module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"copyright":"All right reserved.","policy":"Privacy Policy","rights":"Terms of Use","cookies":"Cookies Policy"},"ru":{"copyright":"Все права защищены.","policy":"Политика конфиденциальности","rights":"Правила использования","cookies":"Политика Cookies"}}')
  delete Component.options._Ctor
}
